// extracted by mini-css-extract-plugin
export default {"container":"BackButton_container__jUa6A","backButtonContainer":"BackButton_backButtonContainer__6eCxa","pathContainer":"BackButton_pathContainer__1C4g0"};